const CONSENT_KEY = 'objetiva_cookie_consent';

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {}
};

export const loadAnalyticsScripts = () => {
  // Google Tag Manager
  if (!window.__gtm_loaded) {
    window.__gtm_loaded = true;
    const gtm = document.createElement('script');
    gtm.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-NWLLW7VG');`;
    document.head.appendChild(gtm);
  }

  // LeadStaker
  if (!window.__leadstaker_loaded) {
    window.__leadstaker_loaded = true;
    const ls = document.createElement('script');
    ls.innerHTML = `(function(l,d,s,t,k){fetch(t+"?client="+k,{headers:{href:l.location.href,p:l.performance.now()}}).then(function(o){o.json().then(function(o){l.LTK_DATA=o;var c=d.createElement(s);d.body.appendChild((c.innerHTML=o.js,c))})})})(window,document,'script','https://api.leadstaker.com/chats','65e8abcda45ae700231ed661');`;
    document.body.appendChild(ls);
  }

  // RD Station
  if (!window.__rdstation_loaded) {
    window.__rdstation_loaded = true;
    const rd = document.createElement('script');
    rd.type = 'text/javascript';
    rd.async = true;
    rd.src = 'https://d335luupugsy2.cloudfront.net/js/loader-scripts/ffb11b7a-ce1a-4d99-8bdb-440cc5fadd3e-loader.js';
    document.body.appendChild(rd);
  }
};
